module.exports = __webpack_public_path__ + "img/oops.fdb4c59d.svg";